import React from "react";
import { useTranslation } from "localization/translation";
import { BUTTONS_TYPE } from "Constants";
import { StyledButton } from "components";

export const UserDefaultPlan = ({
  plan,
  actionHandler,
}) => {
  const translation = useTranslation();

  if(!plan) {
    return null
  }

  return (
    <div>
      <div className="user_wrapper p-4">
        <div className="company_filed">
          <h6 className="font-weight-bold font-size-lg mb-0 text-black text-capitalize">
            {translation.user_default_plan}
          </h6>
        </div>
        <div className="user_actions">
          <div className="activate_field">
            <StyledButton
              className={BUTTONS_TYPE.edit}
              name={translation.edit}
              onClick={actionHandler}
            />
          </div>
        </div>
      </div>
      <div className="user_info_wrapper p-4 mb-spacing-6">
        <div className="about_user pr-4">
          <div className="informative_section_plan">
            <div className="informative_title">
              <p className="font-weight-bold user_info_text">
                {translation.plan_name}
              </p>
              <p className="font-weight-bold user_info_text">
                {translation.plan_billing_period}
              </p>
              <p className="font-weight-bold user_info_text">
                {translation.plan_price_paid}
              </p>
            </div>
            <div className="informative_text">
              <p className="font-size-sm user_info_text">{plan.plan_name}</p>
              <p className="font-size-sm user_info_text capitalize">{plan.plan_type}</p>
              <p className="font-size-sm user_info_text">{plan.price} {plan.currency_code}</p>
            </div>
          </div>
        </div>
        <div className="about_company pr-4 pl-4">
          <div className="informative_section_plan">
            <div className="informative_title">
              <p className="font-weight-bold user_info_text">
                {translation.free_trial_active}
              </p>
              {
                plan.is_use_free_trial && (
                  <p className="font-weight-bold user_info_text">
                    {translation.free_trial_duration}
                  </p>
                )
              }
              <p className="font-weight-bold user_info_text">
                {translation.paid_subscription}
              </p>
              {
                (plan.subscription_starts_at || plan.subscription_ends_at || plan.billing_expiration_date) && (
                  <p className="font-weight-bold user_info_text">
                    {translation.subscription_period}
                  </p>
                )
              }
              <p className="font-weight-bold user_info_text">
                {translation.plan_unlimited_items}
              </p>
              {
                !plan.unlimited_items && (
                  <p className="font-weight-bold user_info_text">
                    {translation.max_inventory_items}
                  </p>
                )
              }
            </div>
            <div className="informative_text">
              <p className="font-size-sm user_info_text">{plan.is_use_free_trial ? 'True': "False"}</p>
              {
                plan.is_use_free_trial && plan.free_trial_start_at && plan.free_trial_end_at && (
                  <p className="font-size-sm user_info_text">
                    {plan.free_trial_start_at} - {plan.free_trial_end_at}
                  </p>
                )
              }
              <p className="font-size-sm user_info_text">{plan.is_paid ? 'True': "False"}</p>
              {
                (plan.subscription_starts_at || plan.subscription_ends_at || plan.billing_expiration_date) && (
                  <p className="font-size-sm user_info_text">
                    {plan.subscription_starts_at && plan.subscription_ends_at
                      ? `${plan.subscription_starts_at} - ${plan.subscription_ends_at}`
                      : (plan.subscription_ends_at || plan.billing_expiration_date)}
                  </p>
                )
              }
              <p className="font-size-sm user_info_text">{!!plan.unlimited_items ? 'True': "False"}</p>
              {
                !plan.unlimited_items && (
                  <p className="font-size-sm user_info_text">
                    {plan.max_inventory_items_ml}({translation.ml}) / {plan.max_inventory_items_kg_pc}({translation.kg}/{translation.pc})
                  </p>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
